import { useTranslation } from '@packlink/translation-provider';
import * as yup from 'yup';
import { useMemo } from 'react';
import { getCustomsFormValidation } from '../data/validations/customsFormValidations.js';

function useCustomsFormValidationSchema(context) {
  const {
    t
  } = useTranslation();
  return useMemo(() => yup.object().shape(getCustomsFormValidation(t, context)), [t, context]);
}

export { useCustomsFormValidationSchema };
//# sourceMappingURL=useCustomsFormValidationSchema.js.map
